import React from 'react'
import { IProps } from './Interface'
import { Avatar, Box, Typography } from '@material-ui/core'
import useStyles from './Styles'

const Reveal: React.FC<IProps> = ({ avatar, firstName, lastName, school, job }) => {
  const classes = useStyles({})
  const fullName = `${firstName} ${lastName}`

  return (
    <Box className={classes.root} display="inline-flex" alignItems="center">
      <Avatar className={classes.avatar} src={avatar} alt={fullName}>
        {`${firstName.charAt(0)}${lastName.charAt(0)}`}
      </Avatar>
      <Box className={classes.box} display="flex" flexDirection="column" pl={2} pr={8}>
        <Typography id="reveal-user-full-name-answer" variant={'h3'} className={classes.h3}>
          {fullName}
        </Typography>
        <Typography id="reveal-user-school-answer" variant={'body1'} className={classes.body1}>
          {school}
        </Typography>
        <Typography id="reveal-user-job-answer" variant={'body2'} className={classes.body2}>
          {job}
        </Typography>
      </Box>
    </Box>
  )
}

Reveal.defaultProps = {
  avatar: '',
  firstName: '',
  lastName: '',
  school: '',
  job: ''
}

export default Reveal
